// extracted by mini-css-extract-plugin
export default {"wrapper":"l92pZEXA_iYuQ5P3f0uJ"};